module.exports = __webpack_public_path__ + "97286ed17db76251c12601370dbca78b.png";